import React, { useEffect } from 'react'
import helperService from '../services/helperService'

/**
 *
 * @author Jared
 *
 * @param message
 * @param {Boolean} basic - don't bother with header etc
 * @return {Element}
 * @constructor
 */
export default function Loader({message, basic, vars}) {
	useEffect(() => {
		helperService.setThinking()
		return helperService.unsetThinking
	}, [])

	if (basic)
		return (
			<div className="loaderWrapper">
				{/* <div className="loaderMessage">{message || 'loading...'}</div> */}
				<div className="loader">
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		)

	return (
		// <WebUserLayout vars={vars} title="Profile" tooltip={tooltip} items={[{ title: 'Profile' }]} page='LOADER'>
		<div className="bg-[#7f7f7f] text-white h-[100vh]">
			<div className="rama" style={{ paddingTop: 'calc(50vh - 4rem)', textAlign: 'center' }}>
				<img src="/images/newLogoBlack.png" alt="Aggie" className="mb-6 w-[14rem] mx-auto" />
				<i className="fal fa-spinner-third fa-spin mr-1" /> {message || 'starting up...'}
			</div>
			<div className="loader">
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
		// </WebUserLayout>
	)
}
